"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    sendAnalyticsEvent: ()=>sendAnalyticsEvent,
    useSendEvent: ()=>useSendEvent
});
const _reactQuery = require("react-query");
const _api = require("../api");
const sendAnalyticsEvent = async (event)=>{
    const stringEvent = Object.fromEntries(Object.entries(event).map(([key, value])=>[
            key,
            encodeURIComponent(String(value))
        ]));
    const params = new URLSearchParams(stringEvent).toString();
    return _api.api.get(`analytics/v1/track?${params}`);
};
const useSendEvent = ()=>{
    return (0, _reactQuery.useMutation)(sendAnalyticsEvent);
};
